module.exports = "/images/link-dropbox.svg?a8db1f19262c03ae24614a379cf23383";